import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'voice',
    'button'
  ]

  static values = {
    playIcon: { type: String, default: '<svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"></path></svg>' },
    loadingIcon: { type: String, default: '<svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>' }
  }

  connect() {
    this.originalContent = this.buttonTarget.innerHTML
  }

  sample(e) {
    e.preventDefault()

    let voice_id = this.voiceTarget.value
    if (voice_id === '') return

    this.playSample(voice_id)
  }

  playSample(voice_id) {
    this.loading()
    const ctx = new AudioContext();

    fetch(`/ai/voices/${voice_id}`, {
      method: 'GET'
    })
      .then(data => data.arrayBuffer())
      .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
      .then(decodedAudio => {
        const playSound = ctx.createBufferSource();
        playSound.buffer = decodedAudio;
        playSound.connect(ctx.destination);
        playSound.start(ctx.currentTime);

        this.loaded()
      })
      .catch(() => {
        this.loaded()
      })
  }

  loading() {
    this.buttonTarget.innerHTML = this.loadingIconValue
    this.buttonTarget.classList.add('pointer-events-none', 'opacity-75')
  }

  loaded() {
    this.buttonTarget.innerHTML = this.originalContent
    this.buttonTarget.classList.remove('pointer-events-none', 'opacity-75')
  }
}
